import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Field, reduxForm, formValueSelector, getFormValues } from "redux-form";
import { TextField } from "redux-form-material-ui";
import { confirmPasswordReset } from "../../actions/AuthActions";
import RaisedButton from "material-ui/RaisedButton";
import Paper from "material-ui/Paper";
import Password from "material-ui/svg-icons/communication/vpn-key";
import { required, password, confirmPassword } from "../../common/validaciones";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import Util, { SUCCESS } from "../../common/Util";
import { INDEX } from "../../config/RoutesConstants";
import CircularProgress from "material-ui/CircularProgress";

class RecoverPasswordChange extends Component {
	constructor(props) {
		super(props);
		this.state = {
			state: "estado",
			error: "",
			loading: false
		};
		this.onSubmit = this.onSubmit.bind(this);
		this.validateConfirmPassword = this.validateConfirmPassword.bind(this);
	}
	componentWillMount() {
		//aca hacer la verificacion de la URL
		let c = this.props.location.search;
		if (!c) {
			this.props.history.push(INDEX);
		}
	}
	onSubmit(formValues) {
		//se obtiene el código de la URL
		this.setState({ error: "", loading: true });
		let code = /token=([^&]+)/.exec(this.props.location.search)[1];
		this.props.confirmPasswordReset(
			code,
			formValues.password,
			this.confirmPasswordReset.bind(this)
		);
	}
	confirmPasswordReset(value, resp) {
		this.setState({ loading: false });
		if (value) {
			Util.showNoty(
				SUCCESS,
				"Se cambió la contraseña, por favor intente ingresar nuevamente."
			);
			this.props.history.push(INDEX);
		}
		//Util.showNoty(ERROR, "Falló al cambiar contraseña, intente de nuevo.");
	}
	renderConditionalLoading(loading) {
		const { handleSubmit } = this.props;
		if (loading) {
			return (
				<div
					style={{
						padding: 15,
						justifyContent: "center",
						alingItems: "center"
					}}
				>
					<CircularProgress />
				</div>
			);
		} else {
			return (
				<RaisedButton
					label="Cambiar Contraseña"
					onClick={handleSubmit(this.onSubmit.bind(this))}
					primary={true}
					fullWidth
					className="top20"
					style={{ height: 40 }}
				/>
			);
		}
	}
	validateConfirmPassword(value) {
		if (this.props.formValues.password) {
			if (value) {
				return confirmPassword(value, this.props.formValues.password);
			} else {
				return null;
			}
		} else {
			return "Debe Ingresar una contraseña.";
		}
	}
	render() {
		return (
			<div className="screen-login">
				<Paper
					style={{
						flex: 1
					}}
					className="bg-login columns-column-between padding20"
				>
					<div>
						<form>
							<ReactCSSTransitionGroup
								transitionName="loginanim"
								transitionAppear={true}
								transitionAppearTimeout={1000}
								transitionEnter={false}
								transitionLeave={false}
							>
								<div className="container-login top100">
									<Paper className="paper-login">
										<div className="fields-login">
											<h1 className="bottom0" style={{}}>
												Cambiar Contraseña
											</h1>
										</div>
										<div className="fields-login">
											<Password style={{ marginRight: 10, color: "#ccc" }} />
											<Field
												component={TextField}
												className="textField"
												name="password"
												type="password"
												floatingLabelText="Nueva Contraseña"
												validate={[required, password]}
												fullWidth
											/>
										</div>
										<div className="fields-login">
											<Password style={{ marginRight: 10, color: "#ccc" }} />
											<Field
												component={TextField}
												className="textField"
												name="confirm_password"
												type="password"
												floatingLabelText="Confirmar Contraseña"
												validate={[required, this.validateConfirmPassword]}
												fullWidth
											/>
										</div>

										<div
											style={{ color: "red", paddingLeft: 20, paddingTop: 25 }}
										>
											{this.state.error}
										</div>
										{this.renderConditionalLoading(this.state.loading)}
									</Paper>
								</div>
							</ReactCSSTransitionGroup>
						</form>
					</div>
					<div className="text-right version-login">Versión 0.9</div>
				</Paper>
			</div>
		);
	}
}
function mapStateToProps(store) {
	const selector = formValueSelector("recoverPasswordChange");
	return {
		formValuesToSetReady: getFormValues("recoverPasswordChange")(store),
		formValues: selector(store, "password", "confirm_password"),
		login: store.session.authenticated
		//password: store.recoveryPassword.password,
	};
}
function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			confirmPasswordReset
		},
		dispatch
	);
}
export default reduxForm({
	form: "recoverPasswordChange"
})(
	withRouter(
		connect(mapStateToProps, mapDispatchToProps)(RecoverPasswordChange)
	)
);



// WEBPACK FOOTER //
// ./src/screens/login/RecoverPasswordChange.js